"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _icon = _interopRequireDefault(require("../icon/icon.style"));

var _themes = require("../../style/themes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const StyledIconButton = _styledComponents.default.button.attrs({
  type: "button"
})`
  ${({
  theme,
  disabled
}) => (0, _styledComponents.css)`
    ${_styledSystem.margin}
    background: transparent;
    border: none;
    padding: 0;

    &:focus {
      color: ${theme.text.color};
      background-color: transparent;
      outline: solid 3px ${theme.colors.focus};
      z-index: 1;
    }

    &:hover {
      cursor: ${!disabled ? "pointer" : "not-allowed"};
    }

    &::-moz-focus-inner {
      border: none;
    }

    ${_icon.default} {
      ${disabled && `color: ${theme.icon.disabled}`};
      position: relative;

      &:focus {
        border: none;
      }
    }
  `}
`;
StyledIconButton.defaultProps = {
  theme: _themes.baseTheme
};
var _default = StyledIconButton;
exports.default = _default;